import { DashboardPreview } from './DashboardPreview';
import { Icon } from './Icon';
import type { Language } from '../content';

type HeroStageProps = { language: Language };

export function HeroStage({ language }: HeroStageProps) {
  const ar = language === 'ar';

  return (
    <div className="hero-stage">
      <div className="hero-stage__world">
        <figure className="hero-stage__environment">
          <picture>
            <source srcSet="/media/lab-render-640.webp" media="(max-width: 720px)" />
            <img
              src="/media/lab-render-1080.webp"
              width={1078}
              height={941}
              alt={ar ? 'مشهد داخل معمل أسنان رقمي مع تصميم تركيبات على شاشة العرض' : 'A digital dental laboratory bench with restorations displayed on screen'}
              loading="eager"
              decoding="async"
            />
          </picture>
          <div className="hero-stage__ambient" aria-hidden="true" />
        </figure>

        <div className="hero-stage__panel">
          <DashboardPreview language={language} />
          <span className="hero-stage__sheen" aria-hidden="true" />
        </div>

        <div className="hero-stage__status-strip">
          <article>
            <span><Icon name="tooth" /></span>
            <div><small>{ar ? 'حالة جديدة' : 'New case'}</small><strong>{ar ? 'زيركون · 14 وحدة' : 'Zirconia · 14 units'}</strong></div>
            <i><Icon name="check" /></i>
          </article>
          <article>
            <span><Icon name="devices" /></span>
            <div><small>{ar ? 'حالة الاتصال' : 'Connection'}</small><strong>{ar ? 'مزامنة لحظية' : 'Live sync'}</strong></div>
            <b aria-hidden="true" />
          </article>
          <article>
            <span className="hero-stage__status-icon--gold"><Icon name="trend" /></span>
            <div><small>{ar ? 'التسليم في الموعد' : 'On-time delivery'}</small><strong>+18.4%</strong></div>
          </article>
        </div>
      </div>
    </div>
  );
}
